<template lang="pug">
.buttons
    Button.va-button(
        v-for="( button, i ) in buttongroup"
        :key="button.id"
        :index="i"
        :button="button"
        v-if="button.title"
    )
</template>

<script>

import { cloneDeep, filter, get } from 'lodash'

import Button from './Button'

export default {
    name: 'Buttongroup',
    props: {
        section: {
            type: Object,
            required: true,
        },
    },
    components: {
        Button,
    },
    computed: {
        buttongroup() {
            let buttongroup = this.section.contents || []
            return filter(cloneDeep(buttongroup).sort((a, b) => get(a, 'position', 0) - get(b, 'position', 0)), button => {
                if( button.title ) return button
            })
        }
    }
}
</script>


<style lang="sass" scoped>
@import "~bulma/sass/utilities/mixins"

.buttons
    display: flex
    // grid-template-rows: auto
    // grid-template-columns: auto
    // gap: 1rem
    flex-direction: row
    justify-content: center
    // align-items: center
    width: 100%
    flex-wrap: nowrap
    margin: 0 auto
    +mobile
        justify-content: space-between
        flex-direction: column
        &::v-deep .va-button
            margin-bottom: 25px
        // grid-template-columns: repeat(3, minmax(220px, 260px))

</style>
